module.exports = __webpack_public_path__ + "img/price.08573701.svg";